import { Heading, HeadingProps } from "@chakra-ui/react";
import React from "react";
import { FONT_WEIGHT_BOLD } from "./constants";

export const H1: React.FC<HeadingProps> = ({ children, ...rest }) => {
  return <Heading as="h1" fontSize="4xl" fontWeight={FONT_WEIGHT_BOLD} {...rest}>{ children }</Heading>;
};

export const H2: React.FC<HeadingProps> = ({ children, ...rest }) => {
  return <Heading as="h2" fontSize="2xl" fontWeight={FONT_WEIGHT_BOLD} {...rest}>{ children }</Heading>;
};

export const H3: React.FC<HeadingProps> = ({ children, ...rest }) => {
  return <Heading as="h3" fontSize="xl" fontWeight={FONT_WEIGHT_BOLD} {...rest}>{ children }</Heading>;
};

export const Title: React.FC<HeadingProps> = ({ children, ...rest }) => {
  return <Heading as="h4" fontSize="md" fontWeight={FONT_WEIGHT_BOLD} {...rest}>{ children }</Heading>;
};
